<template>
    <div class="contenedor_modal" v-shortkey="['esc']" @shortkey="cerrar">
        <div v-if="modal_cambio_precios" class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container>
                <b-row>
                    <div class="col-sm-7 mt-3 mb-3">
                        <div class="foto">
                            <img :src="`${URL_SERVIDOR + id_foto_producto}`" alt="">
                        </div>
                    </div>
                    <div class="col-sm-5 mt-3">
                        <div class="descripcion">
                            <div class="nombre_producto">
                                {{ objeto_busqueda.nombre }}
                            </div>
                            <div class="sku">
                                SKU: {{ objeto_busqueda.codigo }}
                            </div>
                            <div class="precio_producto">
                                Q{{ objeto_busqueda.precio_venta.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </div>
                            <div class="sub_titulo_precios">
                                Precio de venta
                            </div>

                            <div v-if="permisos['inventarios.busqueda.precio_costo']?.ver || datos_usuario.parametros.roles.includes('ROOT')" class="precio_producto_">
                                Q{{ objeto_busqueda.precio_costo.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </div>
                            <div v-if="permisos['inventarios.busqueda.precio_costo']?.ver || datos_usuario.parametros.roles.includes('ROOT')" class="sub_titulo_precios">
                                Precio de costo
                            </div>

                            <div class="precio_producto__">
                                Q{{ objeto_busqueda.precio_efectivo.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </div>
                            <div class="sub_titulo_precios">
                                Precio de efectivo
                            </div>

                            <b-button v-if="permisos['inventarios.busqueda.actualizar_precios']?.ver || datos_usuario.parametros.roles.includes('ROOT')" type="button"
                                style="margin-top: 10px;" block size="sm" variant="warning"
                                @click="abrir_modal_actualizar_precios()">Actualizar precios</b-button>
                            <b-button v-if="permisos['inventarios.busqueda.movimientos']?.ver || datos_usuario.parametros.roles.includes('ROOT')" type="button"
                                style="margin-top: 10px;" block size="sm" variant="primary"
                                @click="abrir_modal_movimientos_producto()">Movimientos</b-button>
                        </div>
                    </div>
                </b-row>
            </b-container>

        </div>
        <ActualizarPrecios v-if="modal_actualizar_precios" v-on:salir="cerrar_modal_actualizar_precios" />
        <Movimientos v-if="modal_movimientos_producto" v-on:salir="cerrar_modal_movimientos_producto" />
    </div>


    <!-- <div class="contenedor_modal_completo">
        <div class="contenedor_modal_completo_cabecera">
            <b-button type="button" size="sm" variant="danger" @click="cerrar"><i class="fas fa-times"></i></b-button>
        </div>

        <div class="contenedor_modal_completo_contenido">
            <b-container>
                <b-row>
                    <div class="col-sm-7 mt-3">
                        <div class="foto">
                            <img :src="`${URL_SERVIDOR + id_foto_producto}`" alt="">
                        </div>
                    </div>
                    <div class="col-sm-5 mt-3">
                        <div class="descripcion">
                            <div class="nombre_producto">
                                {{ item.nombre }}
                            </div>
                            <div class="sku">
                                SKU: {{ item.codigo }}
                            </div>
                            <div class="precio_producto">
                                Q 1000
                            </div>
                            <b-button type="button" block size="sm" variant="warning">Actualizar</b-button>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>

    </div> -->
</template>

<script>
    import { mapGetters, mapMutations, mapState } from 'vuex'
    import ActualizarPrecios from '../Articulo/ModalActualizarPrecios.vue'
    import Movimientos from './Movimientos/ModalMovimientos.vue'

    export default {
        name: 'FichaProducto',
        computed: {
            ...mapGetters(['URL_SERVIDOR']),
            ...mapState(['objeto_busqueda', 'modal_cambio_precios', 'permisos', 'datos_usuario'])
        },
        components: {
            ActualizarPrecios,
            Movimientos
        },
        data() {
            return {
                id_foto_producto: '',
                modal_actualizar_precios: false,
                modal_movimientos_producto: false
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            abrir_modal_actualizar_precios() {
                this.modal_actualizar_precios = true
            },
            cerrar_modal_actualizar_precios() {
                this.$emit('reset_precios')
                this.modal_actualizar_precios = false
                this.set_modal_cambio_precios(true)
            },
            validar_formatos_diponibles() {

                if (Object.keys(this.objeto_busqueda.formatos).includes('large')) {
                    console.log('large')
                    this.id_foto_producto = this.objeto_busqueda.formatos.large.url
                } else if (Object.keys(this.objeto_busqueda.formatos).includes('medium')) {
                    console.log('medium')
                    this.id_foto_producto = this.objeto_busqueda.formatos.medium.url
                } else if (Object.keys(this.objeto_busqueda.formatos).includes('small')) {
                    console.log('small')
                    this.id_foto_producto = this.objeto_busqueda.formatos.small.url
                } else {
                    console.log('thumbnail')
                    this.id_foto_producto = this.objeto_busqueda.formatos.thumbnail.url
                }
            },
            abrir_modal_movimientos_producto() {
                this.modal_movimientos_producto = true
            },
            cerrar_modal_movimientos_producto() {
                this.modal_movimientos_producto = false
            },
            ...mapMutations(['set_modal_cambio_precios'])
        },
        mounted() {

            this.validar_formatos_diponibles()

        },
    }
</script>

<style scoped>
    .contenedor_modal_cuerpo {
        max-width: 90vw;
        max-height: 90vh;
        overflow-y: auto;
    }

    .descripcion {
        width: 100%;
        border: 2px solid #e9e9e9;
        border-radius: 10px;
        padding: 10px;
    }

    .foto {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid #e9e9e9;
        border-radius: 10px;
    }

    .foto img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }


    .nombre_producto {

        font-size: 25px;
        font-weight: bold;

    }

    .sku {
        font-weight: bold;
        color: #827f7f;

    }

    .precio_producto {
        font-weight: bold;
        color: #AD364A;
        margin-top: 10px;
        font-size: 30px;
        line-height: 28px;
    }

    .precio_producto_ {
        font-weight: bold;
        color: #3f9bc6;
        margin-top: 10px;
        font-size: 30px;
        line-height: 28px;
    }

    .precio_producto__ {
        font-weight: bold;
        color: #d17a38;
        margin-top: 10px;
        font-size: 30px;
        line-height: 28px;
    }

    .sub_titulo_precios {
        color: rgb(143, 144, 166);
        font-size: 12px;
        line-height: 10px;
    }
</style>